import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import SelectOverlay from 'components/Inputs/SelectOverlay';
import { StyledSelect } from './StyledSelect';
import { layers } from 'app/spacing';
import {
  Entities,
  useSelectTypeaheadWithScroll,
} from 'components/Inputs/Select/hooks';
import { useRecordLayoutLogActivityContext } from 'ts-components/RecordLayout/RecordLayoutLogActivityContext';

const MobileActivitySelector = ({
  showLogActivity,
  target,
  onSetVisible,
  scrolled,
  customObjectId,
  shownScrolled,
}) => {
  const { t } = useTranslation();
  const { openLogActivityModal } = useRecordLayoutLogActivityContext();
  const [logActivity, setLogActivity] = useState();
  const selectRef = useRef();

  const [typeaheadProps] = useSelectTypeaheadWithScroll({
    selectRef,
    fieldId: customObjectId,
    entity: Entities.ActivitiesLoggable,
    alwaysOpen: showLogActivity,
    enabled: Boolean(customObjectId),
  });

  useEffect(
    () => {
      if ((scrolled && !shownScrolled) || (!scrolled && shownScrolled)) {
        // makes sure the menus close if scrolled
        onSetVisible(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrolled, shownScrolled]
  );

  return (
    <>
      <SelectOverlay
        show={showLogActivity}
        target={target}
        onHide={() => {
          onSetVisible(false);
          setLogActivity(null);
        }}
        zIndexNudge={layers.content(0, 3)}
      >
        <StyledSelect
          ref={selectRef}
          value={logActivity || null}
          onChange={({ value }) => {
            setLogActivity(value);
            openLogActivityModal(value);
          }}
          autoFocus={false}
          placeholder={t('Find Activity')}
          {...typeaheadProps}
        />
      </SelectOverlay>
    </>
  );
};

export default MobileActivitySelector;
